module.exports = __webpack_public_path__ + "img/card-ticket.e61be3c7.png";